export enum ChoiceIndex {
  'A',
  'B',
  'C',
  'D'
}
